import { ensureLoaded } from "@cervval.js/common/src/tools/object.tools";
import { decorateProxyWithCachedGetValue, PropertyInfos, TypeInfos } from "@cervval.js/ts-reflect/decorator";
import { DomTools } from "../tools";
import { WebComponent } from "./webComponent";
/**
 * HtmlElements is a property decorator that gives access to elements in the WebComponent
 * Searches HtmlElements that have a "ref" corresponding to each property name in the decorated property
 * @param options
 * @param options.refAttribute [default=ref] the attribute to search on
 * @param options.nearest is set to true, will search for the element which has the lowest depth (may be needed for layout components when not using shadow dom)
 * @param options.ensureLoadedClasses ensure the loading of decorated CustomElement 
 * @param typeInfos Typed decorator => typeInfos parameter added at build time (see utils/reflect-ts)
 */
export function TypedHtmlElements(options?: { refAttribute?: string, nearest?: boolean, ensureLoadedClasses?: unknown[] }, typeInfos?: TypeInfos): (classPrototype: unknown, propertyKey: string) => void {
    return decorateProxyWithCachedGetValue((element: WebComponent, propertyKey: string, proxiedPropertyName: string, proxiedPropertyInfos: PropertyInfos) => {
        try {
            // ensure classes are loaded for CustomElement
            ensureLoaded(options?.ensureLoadedClasses);

            // find element
            const elt = DomTools.getElementByRef(element.getContainer(), proxiedPropertyName, options?.refAttribute, { nearest: options?.nearest });

            // ensure element is upgraded by custom element registry (ie the custom element constructor was called)
            customElements.upgrade(elt);

            return elt;
        } catch (err) {
            if (!proxiedPropertyInfos.isOptional) {
                console.error("ref " + proxiedPropertyName + " not found", err);
            }
            return undefined;
        }
    }, typeInfos);
}
